import type { ReactNode } from "react";
import { useStrongAuthRequired } from "@/lib/strong-auth";

/**
 * Renders `children` until Arcade refuses the sign-in for not using strong
 * authentication. Every request fails from then on, so the page would only show
 * an error with a Retry that can't help, behind the dialog that explains what
 * to do.
 */
export function StrongAuthGate({ children }: { children: ReactNode }) {
  return useStrongAuthRequired() ? null : children;
}
